import { styled as r, css as n } from "./styled2.mjs";
import a from "./Accordion.mjs";
import t from "./accordionClasses.mjs";
import i from "./accordionSummaryClasses.mjs";
const e = () => n`
	.${i.expandIconWrapper} {
		visibility: hidden;
	}
`, m = r(a)`
	box-shadow: unset;
	background-color: transparent;
	background-image: unset;
	&.${t.disabled} {
		background-color: transparent;
	}
	&.${t.expanded} {
		margin-top: 0;
		margin-bottom: 0;
		+ .${t.root} {
			padding-top: 12px;
		}
	}
	+ .${t.root} {
		:before {
			display: none;
		}
		:after {
			position: absolute;
			left: 0;
			top: -1px;
			right: 0;
			height: 1px;
			content: '';
			background-color: ${({ theme: o }) => o.palette.grey[300]};
		}
	}
	.${t.root}:first-of-type {
		margin-top: ${({ theme: o }) => o.spacing(1.5)};
	}
	.${t.root}:last-of-type {
		margin-bottom: ${({ theme: o }) => o.spacing(1)};
	}
	${({ expanded: o }) => o && e()};
`;
export {
  m as Accordion,
  e as ExpandedMixin
};
//# sourceMappingURL=styles74.mjs.map
